export enum GameLocationsFilter {
    Away = 'Away',
    Home = 'Home',
    All = 'All'
}